<div class="bg-surface-50 dark:bg-surface-950 flex items-center justify-center min-h-screen min-w-[100vw] overflow-hidden">
  <div class="flex flex-col items-center justify-center">
    <div>
      <div class="w-full bg-surface-0 dark:bg-surface-900 py-20 px-8 sm:px-20 flex flex-col items-center shadow-md" style="border-radius: 1rem">
        <div class="gap-4 flex flex-col items-center">
          <div class="flex justify-center items-center border-2 border-pink-500 rounded-full" style="height: 3.2rem; width: 3.2rem">
            <i class="pi pi-fw pi-exclamation-circle !text-2xl text-pink-500"></i>
          </div>
          <h1 class="text-surface-900 dark:text-surface-0 font-bold text-5xl mb-2">{{ 'rb.404' | translate }}</h1>
          <span class="text-muted-color mb-8">{{ 'rb.pnf' | translate }}</span>
          <div class="col-span-12 mt-8 text-center">
            <p-button label="{{ 'rb.home' | translate }}" routerLink="/" severity="danger" />
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
